<template>
  <div class="CovidBranchesPro" >
    <section id='form-section-banner' :style="{ backgroundImage: 'url(' + require('@/assets/images/masque_banner.jpg') + ')' }">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="form-section-banner-title">
                Branches professionnelles
            </h1>
          </div>
        </div>
      </div>
    </section>
      <div class="container">
        <div class="form_div">
          <div class="form_content">
              <h2>
                Mesures spéciales COVID - Branches professionnelles
              </h2>
              <p>
                Vous trouverez sur cette page l'ensemble des services partagés proposés pour vous soutenir.<br>
                <em>Cliquez sur les mesures pour accéder à leur contenu</em>
              </p>

              <div class="row mt-4">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li>
                      <a class="aide-link" href='https://www.afdas.com/connaitre/observatoire/statistiques-etudes-referentiels/vue-densemble-des-travaux-1' target="_blank">
                        <strong>Diagnostic</strong> de situation économique
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='mailto:contact@cmb-sante.fr' target="_blank">
                        <strong>Expertise prévention</strong>
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='http://www.cmb-sante.fr/contact.php' target="_blank">
                        <strong>Comité Médico Technique</strong>
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href="https://www.audiens.org/solutions/services-aux-entreprises-etudes-et-statistiques.html?univers=e---accompagnement-et-services" target="_blank">
                        Toutes <strong>études ad hoc</strong>
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='http://www.cmb-sante.fr/_upload/ressources/02le_cmb/021presentation_du_cmb/statuts_cmb.pdf' target="_blank">
                        (LOBSTATS) Observatoire des <strong>données médicales des intermittents du spectacle</strong>
                      </a>
                    </li>
                  </ol>
                </div>
              </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CovidBranchesPro',
}
</script>

<style lang="scss">
/*** EXTEND ***/
/* box-shadow */
%boxshadow {
  box-shadow: 0.25rem 0.25rem 0.6rem rgba(0,0,0,0.05), 0 0.5rem 1.125rem rgba(75,0,0,0.05);
}

/*** STYLE ***/

*,
*:before,
*:after {
  box-sizing: border-box;
}

.aide-link {
  text-decoration: none;
}



ol.gradient-list {
  counter-reset: gradient-counter;
  list-style: none;
  margin: 1.75rem 0;
  padding-left: 1rem;
  > li {
    background: white;
    border-radius: 0 0.5rem 0.5rem 0.5rem;
    @extend %boxshadow;
    counter-increment: gradient-counter;
    margin-top: 1rem;
    min-height: 2rem;
    padding: 1rem 1rem 1rem 3rem;
    position: relative;
    &::before,
    &::after {
      background-color: #d6075b;
      content: '';
      height: 2rem;
      left: -0.5rem;
      overflow: hidden;
      position: absolute;
      top: -0.5rem;
      width: 2rem;
    }
    &::before {
      align-items: flex-end;
      @extend %boxshadow;
      content: counter(gradient-counter);
      color: #1d1f20;
      display: flex;
      font-weight: 800;
      color: white;
      justify-content: flex-end;
      padding: 0.23em 0.7em;
      z-index: 1;
    }

    + li {
      margin-top: 2rem;
    }
  }
}


</style>
